<div class="container">
  <div class="d-flex gap-2">
    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Enter date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate1" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate1" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-3 col-sm-12">
      <mat-label>Centre Name</mat-label>
      <mat-select [(ngModel)]="mSelectedCentre" >
        <mat-option *ngFor="let c of centres$|async" [value]="c.centreCode">{{ c.centreName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-mini-fab (click)="searchChildByCode()">
      <mat-icon>search</mat-icon>
    </button>
    <button class="mx-2" mat-mini-fab color="accent" (click)="clearAll()">
      <mat-icon>clear</mat-icon>
    </button>

  </div>
  <div class="card">
    <section class="example-container " tabindex="0">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>  Centre Highlight</h2>
          </li>
          <li class="dropdown m-l-20">
            <label for="search-input"><i class="material-icons search-icon">search</i></label>
            <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                   (keyup)='applyFilter($event)' aria-label="Search box">
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li>
            <button mat-mini-fab color="primary" (click)="addHighlightReport()">
              <mat-icon class="col-white">add</mat-icon>
            </button>
          </li>
          <!--          <li>-->
          <!--            <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()">-->
          <!--              <img src="assets/images/icons/xlsx.png" alt="" />-->
          <!--            </div>-->
          <!--          </li>-->
        </ul>
      </div>

      <table mat-table [dataSource]="dataSource" matSort class="child-table" matSortDisableClear
             matSortDirection="desc">
        <!--  POSITION Column-->
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="#">Sr.</th>
          <td mat-cell *matCellDef="let i = index">
            {{ this.paginator1.pageIndex == 0 ? i + 1 : 1 + i + this.paginator1.pageIndex * this.paginator1.pageSize }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="eventDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Date</th>
          <td mat-cell *matCellDef="let element"> {{ element.eventDate.seconds * 1000 | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <!--      Child Name Column-->
        <ng-container matColumnDef="highlightType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Highlight Type</th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngFor="let h of element.highlights; let last = last">
              <span [innerHTML]="h.highlight"></span><span *ngIf="!last">, </span>
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="centreCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre Name</th>
          <td mat-cell *matCellDef="let element"> {{ element?.centreCode}}</td>
        </ng-container>

        <ng-container matColumnDef="childName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name</th>
          <td mat-cell *matCellDef="let element"> {{ element?.childName}}</td>
        </ng-container>

        <!--     Action-->
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef> Action</th>
          <td mat-cell *matCellDef="let element;let i = index">
            <button mat-icon-button (click)="ViewReportChildCaseStudy(element.id)" color="accent">
              <mat-icon>visibility</mat-icon>
            </button>
            <button mat-icon-button (click)="editReport(element.id)" color="primary">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="deleteReport(element.id,element.centreCode)" color="warn" >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr *matNoDataRow class="mat-row">
          <!--        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>-->
        </tr>
      </table>
    </section>
    <mat-paginator [pageSizeOptions]="[20, 50, 100,500]"
                   showFirstLastButtons
                   aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>
</div>
